// Module
var code = "<div id=\"content\">\n    <p>단어 사이의 관계를 시각화합니다.</p>\n</div>";
// Exports
module.exports = code;